import * as React from "react";
import styled from "styled-components";

import { Metrics } from "../../vars";

const MobileToolbarToggle: React.FC<any> = ({ className, onClick }) => (
  <button className={className} onClick={onClick} aria-label="navigation" />
);

export default styled(MobileToolbarToggle)`
  color: ${p => p.theme.colors.grey500};
  border: none;
  background: none;
  line-height: ${Metrics.LineHeights.MOBILE_TOOLBAR_BUTTON}px;
  padding: 0 19px;
  margin-left: 64px;
  border-right: 1px solid ${p => p.theme.colors.grey200};
  text-align: center;
  height: 64px;
  width: 64px;
  position: relative;

  &:before {
    position: absolute;
    content: "";
    top: 22px;
    left: 20px;
    width: 24px;
    height: 4px;
    border-top: 12px double ${p => p.theme.colors.grey500};
    border-bottom: 4px solid ${p => p.theme.colors.grey500};
  }

  .style--rebrand & {
    &:hover {
      &:before {
        border-color: ${p => p.theme.colors.primary};
      }
    }
  }
`;
